<template>
  <div class="issues">
    <div class="search-and-sort-bar">
      <v-text-field
      v-model="search"
      name="search"
      label="Search"
      single-line
      prepend-icon="search"
      ></v-text-field>
    </div>
    <div class="loader" v-if="status === 'Fetching'">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <h1 v-else-if="errMessage" class="error-fetching">
      {{ errMessage }}
    </h1>

    <v-list subheader v-else-if="filteredIssues.length" three-line>
      <v-list-tile avatar v-for="issue in filteredIssues" :key="issue._id" @click="visitIssue(issue)" class="hover-darken row">
        <v-list-tile-avatar tile class="issue-pic">
          <img :src="issue.screenshotUrl" alt="Project Image" class="issue-screenshot">
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-html="issue.name"></v-list-tile-title>
          <v-list-tile-sub-title class="text--primary">This is some description</v-list-tile-sub-title>
          <v-list-tile-sub-title>Other stuff</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action v-bind:title="(issue.clientStart || issue.created) | timeSince">
          <v-list-tile-title>{{ (issue.clientStart || issue.created) | timeSince }}</v-list-tile-title>
        </v-list-tile-action>
        <v-list-tile-action>
          <v-icon>more_vert</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <div v-else class="no-issues">
      <h2>No issues in this project <v-icon>insert_emoticon</v-icon></h2>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Issues',
  hagridActions: ['issues/getIssues'],
  data() {
    // Searching doesnt work, but the local state is wired up to the input
    return {
      search: '',
    };
  },
  computed: {
    ...mapGetters({
      currentProject: 'projects/currentProject',
    }),
    ...mapState({
      issues: state => _.sortBy(state.issues.data, 'created').reverse(),
      status: state => state.issues.status,
      errMessage: state => state.issues.errMessage,
    }),
    filteredIssues() {
      return this.issues ? this.issues.filter(issue => issue.name.toLowerCase().includes(this.search.toLowerCase().trim())) : [];
    },
  },
  methods: {
    async visitIssue(issue) {
      await this.$store.dispatch('recordings/selectIssue', issue);
      this.$router.push({
        path: `/project/${this.currentProject._id}/recording/${issue.recordingId}`,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1 {
  font-family: 'Karla', sans-serif;
  margin-left: 86px;
  font-size: 34px;
	font-weight: bold;
	line-height: 1.12;
}
/*start search and sort bar styling*/
.search-and-sort-bar {
  display: flex;
  flex-direction: row;
  margin-left: 25px;
  align-items: center;
  justify-content: flex-start;
  height: 100px;
  margin-right: 25px;
}
.number-of-issues {
  width: 80px;
  margin-right: 20px;
  font-weight: bold;
}
.no-issues {
  text-align: center;
}
.row {
  padding: 15px;
  padding-left: 120px;
  .issue-pic {
    width: 100px;
    img {
      max-height: 80px;
      width: 100px;
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Issues.vue